import { render } from "react-dom";
import MobileMenu from "../../components/mobile-menu";

/**
 * Render the Global Search in the Header Nav Right
 */
window.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll('[data-nvm-id="nvw-mobile-menu"]');

	if (!blocks) return;

	Array.from(blocks).forEach((block) => render(<MobileMenu />, block));
});
